import { render, staticRenderFns } from "./AbstractNote.vue?vue&type=template&id=46a27764&"
import script from "./AbstractNote.vue?vue&type=script&lang=js&"
export * from "./AbstractNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports